import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

const tones = {
  sun: 'border-sun text-sun-ink outline-sun/40',
  coral: 'border-coral text-coral-ink outline-coral/40',
  ink: 'border-ink text-ink outline-ink/40',
}

/** Timbro da atlante: doppio bordo, maiuscolo spaziato, leggera rotazione. */
export function Stamp({ children, tone = 'sun', className }: { children: ReactNode; tone?: keyof typeof tones; className?: string }) {
  return (
    <span
      className={cn(
        'inline-block -rotate-2 rounded-sm border-2 px-2.5 py-1 font-body text-[0.7rem] font-semibold uppercase tracking-[0.18em] outline outline-1 outline-offset-[3px]',
        tones[tone],
        className,
      )}
    >
      {children}
    </span>
  )
}
